import { motion } from "framer-motion";
import styled from "styled-components";

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;
  display: flex;
  justify-content: center;
  margin-top: 100px;

  @media screen and (max-width: 991px) {
    margin-top: 30px;
  }
`;

export const BoxContainer = styled.div`
  width: 400px;
  min-height: 650px;
  display: flex;
  flex-direction: column;
  border-radius: 19px;
  background-color: #fff;
  box-shadow: 0 0 2px rgba(15, 15, 15, 0.28);
  position: relative;
  overflow: hidden;
  @media screen and (max-width: 991px) {
    width: 280px;
    min-height: 550px;
  }
`;

export const TopContainer = styled.div`
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 1.8em;
  padding-bottom: 5em;
`;

export const BackDrop = styled(motion.div)`
  width: 160%;
  height: 570px;
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 50%;
  transform: rotate(60deg);
  top: -300px;
  left: -140px;
  /* background: #e9ecef; */
  background: rgb(233, 236, 239);
  background: linear-gradient(
    90deg,
    rgba(233, 236, 239, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  @media screen and (max-width: 991px) {
    top: -280px;
    left: -90px;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const HeaderText = styled.h2`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.24;
  color: #6c757d;
  z-index: 10;
  margin: 0;

  @media screen and (max-width: 991px) {
    font-size: 20px;
  }
`;

export const SmallText = styled.h5`
  color: #6c757d;
  font-weight: 500;
  font-size: 11px;
  z-index: 10;
  margin: 0;
  margin-top: 7px;
`;

export const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 1.8em;
`;

export const backdropVariants = {
  expanded: {
    width: "233%",
    height: "1050px",
    borderRadius: "20%",
    transform: "rotate(60deg)",
  },
  collapsed: {
    width: "160%",
    height: "550px",
    borderRadius: "50%",
    transform: "rotate(60deg)",
  },
};

export const expandingTransition = {
  type: "spring",
  duration: 2.3,
  stiffness: 30,
};
